import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class MessageNotifBannerService {
    messageSubject = new BehaviorSubject<MessageBanner>(null);

    constructor() { }

    flagMessage(message: MessageBanner, timer?: number) {
        this.messageSubject.next(message);
    }

    getMessage(): Observable<MessageBanner> {
        return this.messageSubject;
    }
}

export enum MessageType {
    success = 'success',
    error = 'error',
    warning = 'warning'
}

export interface MessageBanner {
    type: MessageType;
    message: string;
}
